import Vue from 'vue'
import Console from './Client.vue'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueResource from 'vue-resource'
import axios from 'axios';
import qs from 'qs';
Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;
Vue.use(VueResource)
Vue.use(ElementUI)


new Vue({
    router,
    render: h => h(Console)
}).$mount('#client')
